import { z } from 'zod';
import { SiteDate, type SiteReportSnapshot } from './site';

export const SiteReviewState = z.enum(['queue', 'submitted', 'verified', 'returned', 'accepted', 'rejected']);
export const SiteReportListQuery = z
  .strictObject({
    state: SiteReviewState.default('queue'),
    dateFrom: SiteDate.optional(),
    dateTo: SiteDate.optional(),
    packageId: z.uuid().optional(),
    limit: z.coerce.number().int().min(1).max(50).default(20),
    cursor: z.string().min(1).max(1024).optional(),
  })
  .refine((q) => !q.dateFrom || !q.dateTo || q.dateFrom <= q.dateTo, {
    message: 'Начало периода позже окончания',
  });
export type SiteReportListQuery = z.infer<typeof SiteReportListQuery>;
export const SiteReportSummary = z.object({
  id: z.uuid(),
  projectId: z.uuid(),
  packageId: z.uuid(),
  packageName: z.string(),
  authorId: z.uuid(),
  authorName: z.string(),
  reportDay: SiteDate,
  shiftKey: z.string(),
  revision: z.number().int().positive(),
  state: z.enum(['submitted', 'verified', 'returned', 'accepted', 'rejected']),
});
export const SiteReportList = z.object({
  items: z.array(SiteReportSummary),
  nextCursor: z.string().nullable(),
});
export type SiteReportList = z.infer<typeof SiteReportList>;

/** Подсказки чтения; не заменяют повторную авторизацию и проверки источников в транзакции. */
export const SiteReviewMetadata = z.object({
  currentRevision: z.number().int().positive(),
  projectName: z.string(),
  packageName: z.string(),
  authorName: z.string(),
  decisionActorName: z.string().nullable(),
  labelsAreCurrent: z.literal(true),
  lines: z.array(z.object({ lineId: z.uuid(), name: z.string() })),
  sourceRevisions: z.array(
    z.object({ type: z.literal('schedule'), id: z.uuid(), revision: z.number().int() }),
  ),
  basisCurrent: z.boolean(),
  capabilities: z.object({
    verify: z.boolean(),
    return: z.boolean(),
    accept: z.boolean(),
    /** «Открыть снова» принятый отчёт (ПР-19): руководитель проекта */
    reopen: z.boolean().optional(),
  }),
  restrictions: z.array(z.object({ code: z.string(), message: z.string() })),
});
export type SiteReviewContext = z.infer<typeof SiteReviewMetadata> & { report: SiteReportSnapshot };
